module.exports = __webpack_public_path__ + "static/media/mitsubishi-vial.ebe06083.svg";